import { BrandMark } from './brand';
import { cx } from './styles';

interface SpinnerProps {
  readonly size?: 'sm' | 'md';
}

export function Spinner({ size = 'md' }: SpinnerProps) {
  const dimensions = size === 'sm' ? 'h-4 w-4 border-2' : 'h-6 w-6 border-[3px]';
  return (
    <span
      role="status"
      aria-label="Bezig met laden"
      className={`${dimensions} inline-block animate-spin rounded-full border-current border-r-transparent`}
    />
  );
}

const loadingTones = {
  app: 'bg-slate-50',
  child: 'bg-cream',
};

export function LoadingScreen({ tone = 'app' }: { readonly tone?: keyof typeof loadingTones }) {
  return (
    <div
      className={cx(
        'flex min-h-screen flex-col items-center justify-center gap-5',
        loadingTones[tone],
      )}
    >
      <BrandMark size="lg" className="motion-safe:animate-pulse" />
      <span className="text-brand-700">
        <Spinner size="sm" />
      </span>
    </div>
  );
}
